webpackJsonp([1],Array(52).concat([
/* 52 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(149)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(201),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Home = __webpack_require__(173);

var _Home2 = _interopRequireDefault(_Home);

var _Products = __webpack_require__(179);

var _Products2 = _interopRequireDefault(_Products);

var _Product = __webpack_require__(175);

var _Product2 = _interopRequireDefault(_Product);

var _ProductList = __webpack_require__(177);

var _ProductList2 = _interopRequireDefault(_ProductList);

var _ProductView = __webpack_require__(178);

var _ProductView2 = _interopRequireDefault(_ProductView);

var _ProductForm = __webpack_require__(176);

var _ProductForm2 = _interopRequireDefault(_ProductForm);

var _FwUpdate = __webpack_require__(170);

var _FwUpdate2 = _interopRequireDefault(_FwUpdate);

var _FwUpdateForm = __webpack_require__(171);

var _FwUpdateForm2 = _interopRequireDefault(_FwUpdateForm);

var _FwUpdateList = __webpack_require__(172);

var _FwUpdateList2 = _interopRequireDefault(_FwUpdateList);

var _Things = __webpack_require__(184);

var _Things2 = _interopRequireDefault(_Things);

var _Thing = __webpack_require__(180);

var _Thing2 = _interopRequireDefault(_Thing);

var _ThingList = __webpack_require__(182);

var _ThingList2 = _interopRequireDefault(_ThingList);

var _ThingView = __webpack_require__(183);

var _ThingView2 = _interopRequireDefault(_ThingView);

var _ThingForm = __webpack_require__(181);

var _ThingForm2 = _interopRequireDefault(_ThingForm);

var _Clients = __webpack_require__(168);

var _Clients2 = _interopRequireDefault(_Clients);

var _Client = __webpack_require__(164);

var _Client2 = _interopRequireDefault(_Client);

var _ClientList = __webpack_require__(166);

var _ClientList2 = _interopRequireDefault(_ClientList);

var _ClientView = __webpack_require__(167);

var _ClientView2 = _interopRequireDefault(_ClientView);

var _ClientForm = __webpack_require__(165);

var _ClientForm2 = _interopRequireDefault(_ClientForm);

var _DeviceList = __webpack_require__(169);

var _DeviceList2 = _interopRequireDefault(_DeviceList);

var _Users = __webpack_require__(189);

var _Users2 = _interopRequireDefault(_Users);

var _User = __webpack_require__(185);

var _User2 = _interopRequireDefault(_User);

var _UserList = __webpack_require__(187);

var _UserList2 = _interopRequireDefault(_UserList);

var _UserView = __webpack_require__(188);

var _UserView2 = _interopRequireDefault(_UserView);

var _UserForm = __webpack_require__(186);

var _UserForm2 = _interopRequireDefault(_UserForm);

var _ErrorPage = __webpack_require__(52);

var _ErrorPage2 = _interopRequireDefault(_ErrorPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = [{ path: '/', component: _Home2.default }, { path: '/users',
  component: _Users2.default,
  children: [{ path: '', component: _UserList2.default }, {
    path: ':user_id(\\d+)',
    component: _User2.default,
    children: [{ path: '', component: _UserView2.default }, { path: 'edit', component: _UserForm2.default, props: { update: true } }]
  }]
}, { path: '/clients',
  component: _Clients2.default,
  children: [{ path: '', component: _ClientList2.default }, { path: 'create', component: _ClientForm2.default, props: { update: false } }, {
    path: ':client_id(\\d+)',
    component: _Client2.default,
    children: [{ path: '', component: _ClientView2.default }, { path: 'edit', component: _ClientForm2.default, props: { update: true } }, { path: 'devices', component: _DeviceList2.default }]
  }]
}, {
  path: '/products',
  component: _Products2.default,
  children: [{ path: '', component: _ProductList2.default }, { path: 'create', component: _ProductForm2.default, props: { update: false } }, {
    path: ':product_id(\\d+)',
    component: _Product2.default,
    children: [{ path: '', component: _ProductView2.default }, { path: 'edit', component: _ProductForm2.default, props: { update: true } }, {
      path: 'things',
      component: _Things2.default,
      children: [{ path: '', component: _ThingList2.default }, { path: 'create', component: _ThingForm2.default, props: { update: false } }, {
        path: ':thing_id(\\d+)',
        component: _Thing2.default,
        children: [{ path: '', component: _ThingView2.default }, { path: 'edit', component: _ThingForm2.default, props: { update: true } }]
      }]
    }, { path: 'fw_updates',
      component: _FwUpdate2.default,
      children: [{ path: '', component: _FwUpdateList2.default }, { path: 'create', component: _FwUpdateForm2.default }]
    }]
  }]
}, { path: '*', components: { fullscreen: _ErrorPage2.default } }];

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(33);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(34);

var _vuex2 = _interopRequireDefault(_vuex);

var _mutations = __webpack_require__(81);

var _mutations2 = _interopRequireDefault(_mutations);

var _actions = __webpack_require__(80);

var _actions2 = _interopRequireDefault(_actions);

var _api = __webpack_require__(79);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var store = new _vuex2.default.Store({
  strict: "production" !== 'production',
  state: {
    authenticated: !!window.localStorage.getItem('iot.' + 'access_token'),
    accessToken: window.localStorage.getItem('iot.' + 'access_token'),
    refreshToken: window.localStorage.getItem('iot.' + 'refresh_token'),
    expiresIn: window.localStorage.getItem('iot.' + 'expires_in'),
    customerId: window.localStorage.getItem('iot.' + 'customer_id'),
    organizationId: window.localStorage.getItem('iot.' + 'organization_id'),
    showErrorBubble: null,
    isError: false,
    error: {},
    customer: {},
    organization: {},
    organizations: [],
    product: {},
    products: [],
    productsTotal: 0,
    client: {},
    clients: [],
    clientsTotal: 0,
    thing: {},
    deleteThing: {},
    productThings: [],
    productThingsTotal: 0,
    file: {},
    fwUpdate: {},
    fwUpdates: [],
    fwUpdatesTotal: 0,
    clientDevices: [],
    clientDevicesTotal: 0,
    deleteFwUpdate: {},
    user: {},
    users: [],
    usersTotal: 0,
    userDevices: {},
    owners: [],
    guests: [],
    invitees: [],
    states: [],
    ownedThings: [],
    sharedThings: [],
    invitedThings: []
  },
  mutations: _mutations2.default,
  actions: (0, _actions2.default)(_api2.default)
});

store.dispatch('setToken', store.state.accessToken);

exports.default = store;

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(147)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(198),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(33);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(34);

var _vuex2 = _interopRequireDefault(_vuex);

var _vueRouter = __webpack_require__(59);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _veeValidate = __webpack_require__(56);

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _App = __webpack_require__(57);

var _App2 = _interopRequireDefault(_App);

var _routes = __webpack_require__(53);

var _routes2 = _interopRequireDefault(_routes);

var _index = __webpack_require__(54);

var _index2 = _interopRequireDefault(_index);

var _lodash = __webpack_require__(55);

var _lodash2 = _interopRequireDefault(_lodash);

var _vueLodash = __webpack_require__(58);

var _vueLodash2 = _interopRequireDefault(_vueLodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_veeValidate2.default, {
  errorBagName: 'veeErrors',
  fieldsBagName: 'veeFields'
});
_vue2.default.use(_vueLodash2.default, _lodash2.default);

var router = new _vueRouter2.default({
  mode: 'history',
  linkActiveClass: 'is-active',
  routes: _routes2.default,
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

_vue2.default.filter('numberDisplay', function (value) {
  return value ? value.toLocaleString() : 0;
});

new _vue2.default({
  store: _index2.default,
  router: router,
  el: '#app',
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(21);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(60);

var _axios2 = _interopRequireDefault(_axios);

var _nprogress = __webpack_require__(158);

var _nprogress2 = _interopRequireDefault(_nprogress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var authHeader = void 0;

exports.default = {
  addTokenToHeader: function addTokenToHeader(token) {
    authHeader = 'Bearer ' + token;
  },
  request: function request(method, url, params, data) {
    _nprogress2.default.start();

    return _axios2.default.request({
      method: method,
      url: url,
      params: params,
      data: data,
      responseType: 'json',
      headers: {
        Authorization: authHeader
      }
    }).then(function (response) {
      _nprogress2.default.done();

      return _promise2.default.resolve(response);
    }).catch(function (error) {
      _nprogress2.default.done();

      return _promise2.default.reject(error);
    });
  },
  get: function get(url, params) {
    return this.request('get', url, params);
  },
  post: function post(url, data) {
    return this.request('post', url, {}, data);
  },
  put: function put(url, data) {
    return this.request('put', url, {}, data);
  },
  delete: function _delete(url) {
    return this.request('delete', url);
  }
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(21);

var _promise2 = _interopRequireDefault(_promise);

exports.default = function (api) {
  return {
    setToken: function setToken(context, token) {
      return api.addTokenToHeader(token);
    },
    login: function login(context, params) {
      return api.post('https://api.iot.fusionnextinc.com/v1' + '/auth', params).then(function (response) {
        return context.commit('LOGIN', response.data);
      }).catch(function (error) {
        context.commit('SET_ERROR', error);
        return _promise2.default.reject();
      });
    },
    getCustomer: function getCustomer(context, _ref) {
      var customerId = _ref.customerId,
          params = _ref.params;

      return api.get('https://api.iot.fusionnextinc.com/v1' + '/customers/' + customerId, params).then(function (response) {
        return context.commit('SET_CUSTOMER', response.data);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getProduct: function getProduct(context, _ref2) {
      var productId = _ref2.productId,
          params = _ref2.params;

      return api.get('https://api.iot.fusionnextinc.com/v1' + '/products/' + productId, params).then(function (response) {
        return context.commit('SET_PRODUCT', response.data);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getOrganizationProducts: function getOrganizationProducts(context, _ref3) {
      var organizationId = _ref3.organizationId,
          params = _ref3.params;

      return api.get('https://api.iot.fusionnextinc.com/v1' + '/organizations/' + organizationId + '/products', params).then(function (response) {
        return context.commit('SET_PRODUCTS', response.data);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getClient: function getClient(context, _ref4) {
      var clientId = _ref4.clientId,
          params = _ref4.params;

      return api.get('https://api.iot.fusionnextinc.com/v1' + '/clients/' + clientId, params).then(function (response) {
        return context.commit('SET_CLIENT', response.data);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getOrganizationClients: function getOrganizationClients(context, _ref5) {
      var organizationId = _ref5.organizationId,
          params = _ref5.params;

      return api.get('https://api.iot.fusionnextinc.com/v1' + '/organizations/' + organizationId + '/clients', params).then(function (response) {
        return context.commit('SET_CLIENTS', response.data);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getThing: function getThing(context, _ref6) {
      var thingId = _ref6.thingId,
          params = _ref6.params;

      return api.get('https://api.iot.fusionnextinc.com/v1' + '/things/' + thingId, params).then(function (response) {
        return context.commit('SET_THING', response.data);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getProductThings: function getProductThings(context, _ref7) {
      var productId = _ref7.productId,
          params = _ref7.params;

      return api.get('https://api.iot.fusionnextinc.com/v1' + '/products/' + productId + '/things', params).then(function (response) {
        return context.commit('SET_PRODUCT_THINGS', response.data);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getClientDevices: function getClientDevices(context, _ref8) {
      var clientId = _ref8.clientId,
          params = _ref8.params;

      return api.get('https://api.iot.fusionnextinc.com/v1' + '/clients/' + clientId + '/devices', params).then(function (response) {
        return context.commit('SET_CLIENT_DEVICES', response.data);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getProductFwUpdates: function getProductFwUpdates(context, _ref9) {
      var productId = _ref9.productId,
          params = _ref9.params;

      return api.get('https://api.iot.fusionnextinc.com/v1' + '/products/' + productId + '/fw_updates', params).then(function (response) {
        return context.commit('SET_FW_UPDATES', response.data);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getUser: function getUser(context, _ref10) {
      var userId = _ref10.userId,
          params = _ref10.params;

      return api.get('https://api.iot.fusionnextinc.com/v1' + '/users/' + userId, params).then(function (response) {
        return context.commit('SET_USER', response.data);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    getOrganizationUsers: function getOrganizationUsers(context, _ref11) {
      var organizationId = _ref11.organizationId,
          params = _ref11.params;

      return api.get('https://api.iot.fusionnextinc.com/v1' + '/organizations/' + organizationId + '/users', params).then(function (response) {
        return context.commit('SET_USERS', response.data);
      }).catch(function (error) {
        return context.commit('SET_ERROR', error);
      });
    },
    createProduct: function createProduct(context, data) {
      return api.post('https://api.iot.fusionnextinc.com/v1' + '/products', data).then(function (response) {
        return context.commit('CREATE_PRODUCT', response);
      }).catch(function (error) {
        context.commit('SET_ERROR', error);
        return _promise2.default.reject();
      });
    },
    createClient: function createClient(context, data) {
      return api.post('https://api.iot.fusionnextinc.com/v1' + '/clients', data).then(function (response) {
        return context.commit('CREATE_CLIENT', response);
      }).catch(function (error) {
        context.commit('SET_ERROR', error);
        return _promise2.default.reject();
      });
    },
    updateProduct: function updateProduct(context, _ref12) {
      var productId = _ref12.productId,
          params = _ref12.params;

      return api.put('https://api.iot.fusionnextinc.com/v1' + '/products/' + productId, params).then(function (response) {
        return context.commit('UPDATE_PRODUCT', response);
      }).catch(function (error) {
        context.commit('SET_ERROR', error);
        return _promise2.default.reject();
      });
    },
    updateClient: function updateClient(context, _ref13) {
      var clientId = _ref13.clientId,
          params = _ref13.params;

      return api.put('https://api.iot.fusionnextinc.com/v1' + '/clients/' + clientId, params).then(function (response) {
        return context.commit('UPDATE_CLIENT', response);
      }).catch(function (error) {
        context.commit('SET_ERROR', error);
        return _promise2.default.reject();
      });
    },
    updateThing: function updateThing(context, _ref14) {
      var thingId = _ref14.thingId,
          params = _ref14.params;

      return api.put('https://api.iot.fusionnextinc.com/v1' + '/things/' + thingId, params).then(function (response) {
        return context.commit('UPDATE_THING', response);
      }).catch(function (error) {
        context.commit('SET_ERROR', error);
        return _promise2.default.reject();
      });
    },
    updateUser: function updateUser(context, _ref15) {
      var userId = _ref15.userId,
          params = _ref15.params;

      return api.put('https://api.iot.fusionnextinc.com/v1' + '/users/' + userId, params).then(function (response) {
        return context.commit('UPDATE_USER', response);
      }).catch(function (error) {
        context.commit('SET_ERROR', error);
        return _promise2.default.reject();
      });
    },
    uploadFile: function uploadFile(context, data) {
      return api.post('https://api.iot.fusionnextinc.com/v1' + '/files', data).then(function (response) {
        return context.commit('UPLOAD_FILE', response);
      }).catch(function (error) {
        context.commit('SET_ERROR', error);
        return _promise2.default.reject();
      });
    },
    saveFwUpdate: function saveFwUpdate(context, data) {
      return api.post('https://api.iot.fusionnextinc.com/v1' + '/fw_updates', data).then(function (response) {
        return context.commit('SAVE_FW_UPDATE', response);
      }).catch(function (error) {
        context.commit('SET_ERROR', error);
        return _promise2.default.reject();
      });
    },
    deleteThing: function deleteThing(context, thingId) {
      return api.delete('https://api.iot.fusionnextinc.com/v1' + '/things/' + thingId).then(function (response) {
        return context.commit('DELETE_THING', response);
      }).catch(function (error) {
        context.commit('SET_ERROR', error);
        return _promise2.default.reject();
      });
    },
    deleteFwUpdate: function deleteFwUpdate(context, fwUpdateId) {
      return api.delete('https://api.iot.fusionnextinc.com/v1' + '/fw_updates/' + fwUpdateId).then(function (response) {
        return context.commit('DELETE_FW_UPDATE', response);
      }).catch(function (error) {
        context.commit('SET_ERROR', error);
        return _promise2.default.reject();
      });
    }
  };
};

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  SET_ERROR: function SET_ERROR(state, error) {
    state.isError = true;
    state.error = error;
  },
  CLEAR_ERROR: function CLEAR_ERROR(state) {
    state.isError = false;
  },
  SHOW_ERROR_BUBBLE: function SHOW_ERROR_BUBBLE(state, value) {
    state.showErrorBubble = value;
  },
  LOGIN: function LOGIN(state, data) {
    state.accessToken = data.access_token;
    state.refreshToken = data.refresh_token;
    state.expiresIn = data.expires_in;
    state.customerId = data.customer_id;
  },
  LOGOUT: function LOGOUT(state) {
    state.accessToken = null;
    state.refreshToken = null;
    state.expiresIn = null;
    state.customerId = null;
  },
  SET_AUTHENTICATED: function SET_AUTHENTICATED(state, value) {
    state.authenticated = value;
  },
  SET_CUSTOMER: function SET_CUSTOMER(state, data) {
    state.customer = data;
    state.organizations = data.organizations ? data.organizations.items : [];
  },
  SET_ORGANIZATION: function SET_ORGANIZATION(state, organization) {
    state.organization = organization;
    state.organizationId = organization.id;
  },
  SET_PRODUCT: function SET_PRODUCT(state, data) {
    state.product = data;
  },
  SET_PRODUCTS: function SET_PRODUCTS(state, data) {
    state.products = data.items;
    state.productsTotal = data.total;
  },
  SET_CLIENT: function SET_CLIENT(state, data) {
    state.client = data;
  },
  SET_CLIENTS: function SET_CLIENTS(state, data) {
    state.clients = data.items;
    state.clientsTotal = data.total;
  },
  SET_THING: function SET_THING(state, data) {
    state.thing = data;
    state.owners = data.owners ? data.owners.items : [];
    state.guests = data.guests ? data.guests.items : [];
    state.invitees = data.invitees ? data.invitees.items : [];
    state.states = data.states ? data.states.items : [];
  },
  SET_PRODUCT_THINGS: function SET_PRODUCT_THINGS(state, data) {
    state.productThings = data.items;
    state.productThingsTotal = data.total;
  },
  SET_FW_UPDATES: function SET_FW_UPDATES(state, data) {
    state.fwUpdates = data.items;
    state.fwUpdatesTotal = data.total;
  },
  SET_CLIENT_DEVICES: function SET_CLIENT_DEVICES(state, data) {
    state.clientDevices = data.items;
    state.clientDevicesTotal = data.total;
  },
  SET_USER: function SET_USER(state, data) {
    state.user = data;
    state.ownedThings = data.owned_things ? data.owned_things.items : [];
    state.sharedThings = data.shared_things ? data.shared_things.items : [];
    state.invitedThings = data.invited_things ? data.invited_things.items : [];
    state.userDevices = data.devices ? data.devices.items : [];
  },
  SET_USERS: function SET_USERS(state, data) {
    state.users = data.items;
    state.usersTotal = data.total;
  },
  CREATE_CLIENT: function CREATE_CLIENT(state, response) {
    state.client = response.data;
  },
  CREATE_PRODUCT: function CREATE_PRODUCT(state, response) {
    state.product = response.data;
  },
  UPDATE_PRODUCT: function UPDATE_PRODUCT(state, response) {
    state.product = response.data;
  },
  UPDATE_CLIENT: function UPDATE_CLIENT(state, response) {
    state.client = response.data;
  },
  UPDATE_THING: function UPDATE_THING(state, response) {
    state.thing = response.data;
  },
  UPDATE_USER: function UPDATE_USER(state, response) {
    state.user = response.data;
  },
  UPLOAD_FILE: function UPLOAD_FILE(state, response) {
    state.file = response.data;
  },
  SAVE_FW_UPDATE: function SAVE_FW_UPDATE(state, response) {
    state.fwUpdate = response.data;
  },
  DELETE_THING: function DELETE_THING(state, response) {
    state.deleteThing = response.data.success;
  },
  DELETE_FW_UPDATE: function DELETE_FW_UPDATE(state, response) {
    state.deleteFwUpdate = response.data.success;
  }
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseModal = __webpack_require__(19);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_BaseModal2.default],

  props: {
    title: {
      type: String
    },
    okText: {
      type: String,
      default: 'Ok'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    }
  },

  computed: {
    classes: function classes() {
      return ['modal', 'animated', 'is-active'];
    }
  },

  methods: {
    ok: function ok() {
      this.$emit('ok');
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseModal = __webpack_require__(19);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_BaseModal2.default],

  props: {
    closable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return ['modal', 'animated', 'is-active'];
    }
  }
};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseModal = __webpack_require__(19);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_BaseModal2.default],

  props: {
    closable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return ['modal', 'animated', 'is-active'];
    }
  }
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paging = __webpack_require__(163);

var _paging2 = _interopRequireDefault(_paging);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'vue-bulma-pagination',
  props: {
    urlPrefix: {
      type: String,
      default: '/'
    },
    urlBuilder: {
      type: Function,
      default: function _default(page) {
        return this.normalize(this.urlPrefix + '/' + page);
      }
    },
    currentPage: {
      type: Number,
      default: 1
    },
    lastPage: Number,
    displayPage: {
      type: Number,
      default: 4
    },
    modifiers: {
      type: String,
      default: ''
    },
    prev: {
      type: String,
      default: 'Prev'
    },
    next: {
      type: String,
      default: 'Next'
    }
  },
  methods: {
    getNavClassName: function getNavClassName() {
      var optional = ['', 'is-centered', 'is-right'];
      if (['', 'is-centered', 'is-right'].indexOf(this.modifiers.trim()) >= 0) {
        return 'pagination ' + this.modifiers;
      } else {
        console.warn(" modifiers %s is not within the options ", this.modifiers, optional, '\n see more detail https://github.com/vue-bulma/vue-bulma-pagination#doc');
        return 'pagination';
      }
    },
    getPagingClassName: function getPagingClassName(item) {
      return this.currentPage !== item ? 'pagination-link' : 'pagination-link is-current';
    },
    outOfRegion: function outOfRegion(page) {
      return page < 1 || page > this.lastPage;
    },
    normalize: function normalize(path) {
      return path.replace(/\/+/g, '/');
    }
  },
  computed: {
    pagingList: function pagingList() {
      return (0, _paging2.default)(this.currentPage, this.lastPage, this.displayPage);
    },
    formatCurrentPage: function formatCurrentPage() {
      var currentPage = Number(this.currentPage);
      return currentPage > 0 ? currentPage : 1;
    },
    prevPage: function prevPage() {
      return Math.max(this.formatCurrentPage - 1, 1);
    },
    nextPage: function nextPage() {
      return Math.min(this.formatCurrentPage + 1, this.lastPage);
    }
  }
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Navbar = __webpack_require__(192);

var _Navbar2 = _interopRequireDefault(_Navbar);

var _Sidebar = __webpack_require__(193);

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _AppMain = __webpack_require__(190);

var _AppMain2 = _interopRequireDefault(_AppMain);

var _ErrorBubble = __webpack_require__(191);

var _ErrorBubble2 = _interopRequireDefault(_ErrorBubble);

var _ErrorPage = __webpack_require__(52);

var _ErrorPage2 = _interopRequireDefault(_ErrorPage);

var _Login = __webpack_require__(174);

var _Login2 = _interopRequireDefault(_Login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      hideSidebar: true,
      showErrorPage: false
    };
  },


  computed: {
    authenticated: function authenticated() {
      return this.$store.state.authenticated;
    }
  },

  components: {
    Navbar: _Navbar2.default,
    Sidebar: _Sidebar2.default,
    AppMain: _AppMain2.default,
    ErrorBubble: _ErrorBubble2.default,
    ErrorPage: _ErrorPage2.default,
    Login: _Login2.default
  },

  watch: {
    '$route.query': function $routeQuery() {
      this.hideSidebar = true;
    },
    '$store.state.isError': function $storeStateIsError(isError) {
      if (isError) {
        if (this.$store.state.error.message === 'Network Error') {
          this.$store.commit('SHOW_ERROR_BUBBLE', true);
        } else if (this.$store.state.error.response.status === 404) {
          this.showErrorPage = true;
        } else if (this.$store.state.error.response.status === 401 || this.$store.state.error.response.status === 403) {
          this.$store.commit('LOGOUT');
          this.$store.commit('SET_AUTHENTICATED', false);

          window.localStorage.clear();
        }
      }
      this.$store.commit('CLEAR_ERROR');
    }
  }
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(5);

var _keys2 = _interopRequireDefault(_keys);

var _vueBulmaModal = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      fields: {
        organization_id: this.$store.state.organizationId,
        name: '',
        platform: ''
      },
      isLoading: false,
      showClientCredentialsModal: false
    };
  },


  computed: {
    cancelUrl: function cancelUrl() {
      return this.update ? '/clients/' + this.$route.params.client_id : '/clients';
    }
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.$validator.validateAll().then(function (passed) {
        if (!passed) {
          return;
        }

        _this.isLoading = true;

        _this.createOrUpdateClient(_this.$route.params.client_id, _this.fields).then(function () {
          if (_this.update) {
            _this.$router.push('/clients/' + _this.$store.state.client.id);
          } else {
            _this.showClientCredentialsModal = true;
          }
        }).catch(function () {
          if (_this.$store.state.error.response) {
            (0, _keys2.default)(_this.$store.state.error.response.data.error.validation_errors).forEach(function (key) {
              _this.veeErrors.add(key, _this.$store.state.error.response.data.error.validation_errors[key][0]);
            });
          }

          _this.isLoading = false;
        });
      });
    },
    createOrUpdateClient: function createOrUpdateClient(clientId, params) {
      if (clientId) {
        delete params.platform;
      }

      return clientId ? this.$store.dispatch('updateClient', { clientId: clientId, params: params }) : this.$store.dispatch('createClient', params);
    },
    hideClientCredentialsModal: function hideClientCredentialsModal() {
      this.showClientCredentialsModal = false;

      this.$nextTick(function () {
        this.$router.push('/clients/' + this.$store.state.client.id);
      });
    }
  },

  created: function created() {
    var _this2 = this;

    if (this.update) {
      this.$store.dispatch('getClient', {
        clientId: this.$route.params.client_id
      }).then(function () {
        _this2.fields = {
          name: _this2.$store.state.client.name,
          platform: _this2.$store.state.client.platform
        };
      });
    }
  },


  components: {
    Modal: _vueBulmaModal.Modal
  },

  props: ['update']
};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _vueBulmaPagination = __webpack_require__(9);

var _vueBulmaPagination2 = _interopRequireDefault(_vueBulmaPagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: {
    currentPage: function currentPage() {
      return parseInt(this.$route.query.page) || 1;
    },
    lastPage: function lastPage() {
      return Math.ceil(this.$store.state.clientsTotal / 20);
    }
  },

  methods: {
    buildPaginatorUrls: function buildPaginatorUrls(page) {
      return { query: (0, _extends3.default)({}, this.$route.query, { page: page }) };
    }
  },

  created: function created() {
    this.$store.dispatch('getOrganizationClients', {
      organizationId: this.$store.state.organizationId,
      params: this.$route.query
    });
  },


  watch: {
    '$route.query': function $routeQuery(query) {
      this.$store.dispatch('getOrganizationClients', {
        organizationId: this.$store.state.organizationId,
        params: this.$route.query
      });
    }
  },

  components: {
    Pagination: _vueBulmaPagination2.default
  }
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  created: function created() {
    this.$store.dispatch('getClient', {
      clientId: this.$route.params.client_id
    });
    this.$store.dispatch('getClientDevices', {
      clientId: this.$route.params.client_id,
      params: { limit: 1 }
    });
  }
};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _vueBulmaPagination = __webpack_require__(9);

var _vueBulmaPagination2 = _interopRequireDefault(_vueBulmaPagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: {
    currentPage: function currentPage() {
      return parseInt(this.$route.query.page) || 1;
    },
    lastPage: function lastPage() {
      return Math.ceil(this.$store.state.clientDevicesTotal / 20);
    }
  },

  methods: {
    buildPaginatorUrls: function buildPaginatorUrls(page) {
      return { query: (0, _extends3.default)({}, this.$route.query, { page: page }) };
    }
  },

  created: function created() {
    this.$store.dispatch('getClient', {
      clientId: this.$route.params.client_id
    });

    this.$store.dispatch('getClientDevices', {
      clientId: this.$route.params.client_id,
      params: this.$route.query
    });
  },


  watch: {
    '$route.query': function $routeQuery(query) {
      this.$store.dispatch('getClientDevices', {
        clientId: this.$route.params.client_id,
        params: this.$route.query
      });
    }
  },

  components: {
    Pagination: _vueBulmaPagination2.default
  }
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(21);

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__(5);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      fields: {
        product_id: this.$route.params.product_id,
        version: '',
        description: '',
        filename: ''
      },
      formData: null,
      filename: 'Choose a firmware file ...',
      isLoading: false
    };
  },


  methods: {
    onFileChange: function onFileChange(e) {
      this.formData = new window.FormData();
      this.formData.append('file1', e.target.files[0]);
      this.filename = e.target.files[0].name;
    },
    submit: function submit() {
      var _this = this;

      this.$validator.validateAll().then(function (passed) {
        if (!passed) {
          return;
        }

        _this.isLoading = true;

        _this.uploadFile(_this.formData).then(function () {
          _this.fields.filename = _this.$store.state.file.file1.filename;

          return _this.$store.dispatch('saveFwUpdate', _this.fields);
        }).then(function () {
          _this.$router.push('/products/' + _this.$route.params.product_id + '/fw_updates');
        }).catch(function () {
          if (_this.$store.state.error.response) {
            (0, _keys2.default)(_this.$store.state.error.response.data.error.validation_errors).forEach(function (key) {
              _this.veeErrors.add(key, _this.$store.state.error.response.data.error.validation_errors[key][0]);
            });
          }

          _this.isLoading = false;
        });
      });
    },
    uploadFile: function uploadFile(data) {
      if (!data) {
        return new _promise2.default(function (resolve, reject) {
          resolve();
        });
      }

      return this.$store.dispatch('uploadFile', data);
    }
  },

  created: function created() {
    this.$store.dispatch('getProduct', {
      productId: this.$route.params.product_id
    });
  }
};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _vueBulmaModal = __webpack_require__(31);

var _vueBulmaPagination = __webpack_require__(9);

var _vueBulmaPagination2 = _interopRequireDefault(_vueBulmaPagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      showModal: false,
      apiUrl: 'https://api.iot.fusionnextinc.com/v1',
      fwUpdateId: null
    };
  },


  computed: {
    currentPage: function currentPage() {
      return parseInt(this.$route.query.page) || 1;
    },
    lastPage: function lastPage() {
      return Math.ceil(this.$store.state.fwUpdatesTotal / 20);
    }
  },

  methods: {
    buildPaginatorUrls: function buildPaginatorUrls(page) {
      return { query: (0, _extends3.default)({}, this.$route.query, { page: page }) };
    },
    deleteItem: function deleteItem(fwUpdateId) {
      var _this = this;

      this.showModal = false;

      this.$store.dispatch('deleteFwUpdate', fwUpdateId).then(function () {
        _this.$store.dispatch('getProductFwUpdates', {
          productId: _this.$route.params.product_id,
          params: _this.$route.query
        });
      }).catch(function () {
        _this.$store.commit('SHOW_ERROR_BUBBLE', true);
      });
    }
  },

  created: function created() {
    this.$store.dispatch('getProduct', {
      productId: this.$route.params.product_id
    });

    this.$store.dispatch('getProductFwUpdates', {
      productId: this.$route.params.product_id,
      params: this.$route.query
    });
  },


  watch: {
    '$route.query': function $routeQuery(query) {
      this.$store.dispatch('getProductFwUpdates', {
        productId: this.$route.params.product_id,
        params: this.$route.query
      });
    }
  },

  components: {
    Modal: _vueBulmaModal.Modal,
    Pagination: _vueBulmaPagination2.default
  }
};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  methods: {
    getTotals: function getTotals() {
      this.$store.dispatch('getOrganizationProducts', {
        organizationId: this.$store.state.organizationId,
        params: { limit: 1 }
      });

      this.$store.dispatch('getOrganizationClients', {
        organizationId: this.$store.state.organizationId,
        params: { limit: 1 }
      });

      this.$store.dispatch('getOrganizationUsers', {
        organizationId: this.$store.state.organizationId,
        params: { limit: 1 }
      });
    }
  },

  created: function created() {
    if (this.$store.state.organizationId) {
      this.getTotals();
    }
  },


  watch: {
    '$store.state.organizationId': function $storeStateOrganizationId() {
      this.getTotals();
    }
  }
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      credentials: {
        grant_type: 'password',
        client_id: 'Rwk9j8eaqNMVj2t2v7jfpnCXxiB741yg',
        username: '',
        password: ''
      },
      error: '',
      year: new Date().getFullYear()
    };
  },


  methods: {
    login: function login(event) {
      var _this = this;

      if (event) event.preventDefault();

      this.$validator.validateAll().then(function (passed) {
        if (!passed) {
          return;
        }

        _this.$store.dispatch('login', _this.credentials).then(function () {
          _this.$store.dispatch('setToken', _this.$store.state.accessToken);

          window.localStorage.setItem('iot.' + 'access_token', _this.$store.state.accessToken);
          window.localStorage.setItem('iot.' + 'refresh_token', _this.$store.state.refreshToken);
          window.localStorage.setItem('iot.' + 'expires_in', _this.$store.state.expiresIn);
          window.localStorage.setItem('iot.' + 'customer_id', _this.$store.state.customerId);

          window.localStorage.setItem('iot.' + 'token_expiration_time', Math.round(Date.now() / 1000) + parseInt(_this.$store.state.expiresIn));
        }).then(function () {
          _this.$router.push('/');

          _this.$store.commit('SET_AUTHENTICATED', true);
        }).catch(function () {
          if (_this.$store.state.error.response) {
            _this.error = _this.$store.state.error.response.data.error_description;
            return;
          }

          _this.error = _this.$store.state.error.message;
          return;
        });
      });
    },
    clearError: function clearError() {
      this.$store.commit('CLEAR_ERROR');
      this.error = '';
    }
  }
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(5);

var _keys2 = _interopRequireDefault(_keys);

var _slug = __webpack_require__(160);

var _slug2 = _interopRequireDefault(_slug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      fields: {
        organization_id: this.$store.state.organizationId,
        name: '',
        slug: ''
      },
      isLoading: false
    };
  },


  computed: {
    cancelUrl: function cancelUrl() {
      return this.update ? '/products/' + this.$route.params.product_id : '/products';
    }
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.$validator.validateAll().then(function (passed) {
        if (!passed) {
          return;
        }

        _this.isLoading = true;

        _this.createOrUpdateProduct(_this.$route.params.product_id, _this.fields).then(function () {
          _this.$router.push('/products/' + _this.$store.state.product.id);
        }).catch(function () {
          if (_this.$store.state.error.response) {
            (0, _keys2.default)(_this.$store.state.error.response.data.error.validation_errors).forEach(function (key) {
              _this.veeErrors.add(key, _this.$store.state.error.response.data.error.validation_errors[key][0]);
            });
          }

          _this.isLoading = false;
        });
      });
    },
    createOrUpdateProduct: function createOrUpdateProduct(productId, params) {
      if (productId) {
        delete params.slug;
      }

      return productId ? this.$store.dispatch('updateProduct', { productId: productId, params: params }) : this.$store.dispatch('createProduct', params);
    }
  },

  beforeCreate: function beforeCreate() {
    this.slug = _slug2.default;
  },
  created: function created() {
    var _this2 = this;

    if (this.update) {
      this.$store.dispatch('getProduct', {
        productId: this.$route.params.product_id
      }).then(function () {
        _this2.fields = {
          name: _this2.$store.state.product.name,
          slug: _this2.$store.state.product.slug
        };
      });
    }
  },


  props: ['update']
};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _vueBulmaPagination = __webpack_require__(9);

var _vueBulmaPagination2 = _interopRequireDefault(_vueBulmaPagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: {
    currentPage: function currentPage() {
      return parseInt(this.$route.query.page) || 1;
    },


    lastPage: function lastPage() {
      return Math.ceil(this.$store.state.productsTotal / 20);
    }
  },

  methods: {
    buildPaginatorUrls: function buildPaginatorUrls(page) {
      return { query: (0, _extends3.default)({}, this.$route.query, { page: page }) };
    }
  },

  created: function created() {
    this.$store.dispatch('getOrganizationProducts', {
      organizationId: this.$store.state.organizationId,
      params: this.$route.query
    });
  },


  watch: {
    '$route.query': function $routeQuery(query) {
      this.$store.dispatch('getOrganizationProducts', {
        organizationId: this.$store.state.organizationId,
        params: this.$route.query
      });
    }
  },

  components: {
    Pagination: _vueBulmaPagination2.default
  }
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  created: function created() {
    this.$store.dispatch('getProduct', {
      productId: this.$route.params.product_id
    });
    this.$store.dispatch('getProductThings', {
      productId: this.$route.params.product_id,
      params: { limit: 1 }
    });
    this.$store.dispatch('getProductFwUpdates', {
      productId: this.$route.params.product_id,
      params: { limit: 1 }
    });
  }
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(5);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      fields: {
        name: ''
      },
      isLoading: false
    };
  },


  methods: {
    submit: function submit() {
      var _this = this;

      this.$validator.validateAll().then(function (passed) {
        if (!passed) {
          return;
        }

        _this.isLoading = true;

        _this.$store.dispatch('updateThing', {
          thingId: _this.$route.params.thing_id,
          params: _this.fields
        }).then(function () {
          _this.$router.push('/products/' + _this.$route.params.product_id + '/things/' + _this.$route.params.thing_id);
        }).catch(function () {
          if (_this.$store.state.error.response) {
            (0, _keys2.default)(_this.$store.state.error.response.data.error.validation_errors).forEach(function (key) {
              _this.veeErrors.add(key, _this.$store.state.error.response.data.error.validation_errors[key][0]);
            });
          }

          _this.isLoading = false;
        });
      });
    }
  },

  created: function created() {
    var _this2 = this;

    this.$store.dispatch('getProduct', {
      productId: this.$route.params.product_id
    });

    this.$store.dispatch('getThing', {
      thingId: this.$route.params.thing_id
    }).then(function () {
      _this2.fields = {
        name: _this2.$store.state.thing.name
      };
    });
  }
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(5);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _vueBulmaPagination = __webpack_require__(9);

var _vueBulmaPagination2 = _interopRequireDefault(_vueBulmaPagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      searchValue: this.$route.query.name || this.$route.query.identifier || '',
      searchKey: this.$route.query.name ? 'name' : this.$route.query.identifier ? 'identifier' : 'name',

      searchParams: {}
    };
  },


  computed: {
    currentPage: function currentPage() {
      return parseInt(this.$route.query.page) || 1;
    },
    lastPage: function lastPage() {
      return Math.ceil(this.$store.state.productThingsTotal / 20);
    }
  },

  methods: {
    buildPaginatorUrls: function buildPaginatorUrls(page) {
      return { query: (0, _extends3.default)({}, this.$route.query, { page: page }) };
    },
    searchThings: function searchThings() {
      var _this = this;

      this.searchParams[this.searchKey] = this.searchValue;
      this.searchParams.created_after = this.createdAfter;
      this.searchParams.created_before = this.createdBefore;

      (0, _keys2.default)(this.searchParams).filter(function (key) {
        return !_this.searchParams[key];
      }).forEach(function (key) {
        return delete _this.searchParams[key];
      });

      this.$router.push({
        path: '/products/' + this.$route.params.product_id + '/things',
        query: this.searchParams
      });
    }
  },

  created: function created() {
    this.$store.dispatch('getProduct', {
      productId: this.$route.params.product_id
    });

    this.$store.dispatch('getProductThings', {
      productId: this.$route.params.product_id,
      params: this.$route.query
    });
  },


  watch: {
    '$route.query': function $routeQuery(query) {
      this.$store.dispatch('getProductThings', {
        productId: this.$route.params.product_id,
        params: this.$route.query
      });
    },
    searchKey: function searchKey(newSearchKey, oldSearchKey) {
      delete this.searchParams[oldSearchKey];
    }
  },

  components: {
    Pagination: _vueBulmaPagination2.default
  }
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueBulmaModal = __webpack_require__(31);

exports.default = {
  data: function data() {
    return {
      showModal: false
    };
  },


  methods: {
    deleteItem: function deleteItem() {
      var _this = this;

      this.showModal = false;
      this.$store.dispatch('deleteThing', this.$route.params.thing_id).then(function () {
        _this.$router.push('/products/' + _this.$route.params.product_id + '/things');
      }).catch(function () {
        _this.$store.commit('SHOW_ERROR_BUBBLE', true);
      });
    },
    openDeleteThingModal: function openDeleteThingModal() {
      this.showModal = true;
    },
    closeDeleteThingModal: function closeDeleteThingModal() {
      this.showModal = false;
    }
  },

  created: function created() {
    this.$store.dispatch('getProduct', {
      productId: this.$route.params.product_id
    });

    this.$store.dispatch('getThing', {
      thingId: this.$route.params.thing_id,
      params: {
        include: 'owners,guests,invitees,states:sort(created_at):order(desc):limit(1)'
      }
    });
  },


  components: {
    Modal: _vueBulmaModal.Modal
  }
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(5);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      fields: {
        name: ''
      },
      isLoading: false
    };
  },


  methods: {
    submit: function submit() {
      var _this = this;

      this.$validator.validateAll().then(function (passed) {
        if (!passed) {
          return;
        }

        _this.isLoading = true;

        _this.$store.dispatch('updateUser', {
          userId: _this.$route.params.user_id,
          params: _this.fields
        }).then(function () {
          _this.$router.push('/users/' + _this.$route.params.user_id);
        }).catch(function () {
          if (_this.$store.state.error.response) {
            (0, _keys2.default)(_this.$store.state.error.response.data.error.validation_errors).forEach(function (key) {
              _this.veeErrors.add(key, _this.$store.state.error.response.data.error.validation_errors[key][0]);
            });
          }

          _this.isLoading = false;
        });
      });
    }
  },

  created: function created() {
    var _this2 = this;

    this.$store.dispatch('getUser', {
      userId: this.$route.params.user_id
    }).then(function () {
      _this2.fields = {
        name: _this2.$store.state.user.name
      };
    });
  }
};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(5);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _vueBulmaPagination = __webpack_require__(9);

var _vueBulmaPagination2 = _interopRequireDefault(_vueBulmaPagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      searchValue: this.$route.query.name || this.$route.query.email || '',
      searchKey: this.$route.query.name ? 'name' : this.$route.query.email ? 'email' : 'name',

      searchParams: {}
    };
  },


  computed: {
    currentPage: function currentPage() {
      return parseInt(this.$route.query.page) || 1;
    },
    lastPage: function lastPage() {
      return Math.ceil(this.$store.state.usersTotal / 20);
    }
  },

  methods: {
    buildPaginatorUrls: function buildPaginatorUrls(page) {
      return { query: (0, _extends3.default)({}, this.$route.query, { page: page }) };
    },
    searchUsers: function searchUsers() {
      var _this = this;

      this.searchParams[this.searchKey] = this.searchValue;
      this.searchParams.created_after = this.createdAfter;
      this.searchParams.created_before = this.createdBefore;

      (0, _keys2.default)(this.searchParams).filter(function (key) {
        return !_this.searchParams[key];
      }).forEach(function (key) {
        return delete _this.searchParams[key];
      });

      this.$router.push({
        path: '/users',
        query: this.searchParams
      });
    }
  },

  created: function created() {
    this.$store.dispatch('getOrganizationUsers', {
      organizationId: this.$store.state.organizationId,
      params: this.$route.query
    });
  },


  watch: {
    '$route.query': function $routeQuery(query) {
      this.$store.dispatch('getOrganizationUsers', {
        organizationId: this.$store.state.organizationId,
        params: this.$route.query
      });
    }
  },

  components: {
    Pagination: _vueBulmaPagination2.default
  }
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  created: function created() {
    this.$store.dispatch('getUser', {
      userId: this.$route.params.user_id,
      params: {
        include: 'owned_things,shared_things,invited_things,devices'
      }
    });
  }
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  computed: {
    show: function show() {
      return this.$store.state.showErrorBubble;
    }
  },

  methods: {
    hide: function hide(delay) {
      var _this = this;

      setTimeout(function () {
        if (_this.show) {
          _this.$store.commit('SHOW_ERROR_BUBBLE', false);
        }
      }, delay);
    }
  }
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ['showBurger'],

  methods: {
    organizationIsActive: function organizationIsActive(organizationId) {
      return organizationId === parseInt(this.$store.state.organizationId);
    },
    setOrganization: function setOrganization(organizationId) {
      var organization = this.$store.state.organizations.find(function (organization) {
        return organization.id === parseInt(organizationId);
      });

      this.$store.commit('SET_ORGANIZATION', organization);

      window.localStorage.setItem('iot.' + 'organization_id', organizationId);
    },
    switchOrganization: function switchOrganization(organizationId) {
      this.setOrganization(organizationId);

      this.$router.push('/');
    },


    logout: function logout(event) {
      if (event) event.preventDefault();

      this.$store.commit('LOGOUT');
      this.$store.commit('SET_AUTHENTICATED', false);

      window.localStorage.clear();
    }
  },

  created: function created() {
    var _this = this;

    this.$store.dispatch('getCustomer', {
      customerId: this.$store.state.customerId,
      params: {
        include: 'organizations'
      }
    }).then(function () {
      if (_this.$store.state.organizationId) {
        return _this.setOrganization(_this.$store.state.organizationId);
      }

      return _this.setOrganization(_this.$store.state.organizations[0].id);
    });
  }
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  methods: {
    logout: function logout(event) {
      if (event) event.preventDefault();

      this.$store.commit('LOGOUT');
      this.$store.commit('SET_AUTHENTICATED', false);

      window.localStorage.clear();
    }
  }
};

/***/ }),
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(217),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(213),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(231),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(233),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(202),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(220),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(221),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(209),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(155)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(224),
  /* scopeId */
  "data-v-7e989d2f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(211),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(229),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(223),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(228),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(210),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(214),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(207),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(205),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(230),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(212),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(153)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(219),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(208),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(226),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(199),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(206),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(150)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(203),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(218),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(156)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(227),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(148)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(200),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(151)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(204),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(152)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(215),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(232),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(216),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(225),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(154)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(222),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.authenticated) ? _c('div', [_c('router-view', {
    attrs: {
      "name": "fullscreen"
    }
  }), _vm._v(" "), (_vm.showErrorPage) ? _c('error-page') : _vm._e(), _vm._v(" "), _c('error-bubble'), _vm._v(" "), _c('navbar', {
    attrs: {
      "showBurger": _vm.hideSidebar
    },
    on: {
      "toggleSidebar": function($event) {
        _vm.hideSidebar = !_vm.hideSidebar
      }
    }
  }), _vm._v(" "), _c('sidebar', {
    class: {
      'is-hidden-touch': _vm.hideSidebar
    }
  }), _vm._v(" "), _c('app-main')], 1) : _c('div', [_c('login')], 1)])
},staticRenderFns: []}

/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_vm._v("Users")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/users/" + (this.$route.params.user_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.user.name || 'No name'))])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("User name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.name),
      expression: "fields.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-danger': _vm.veeErrors.has('name')
    },
    attrs: {
      "name": "name",
      "type": "text",
      "placeholder": "User name",
      "data-vv-as": "User name"
    },
    domProps: {
      "value": (_vm.fields.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fields, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('name')),
      expression: "veeErrors.has('name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('name')))])]), _vm._v(" "), _c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    class: {
      'button': true, 'is-primary': true, 'is-loading': _vm.isLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": ("/users/" + (this.$route.params.user_id)),
      "exact": ""
    }
  }, [_vm._v("Cancel")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Edit user name")])])
}]}

/***/ }),
/* 200 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "mode": "in-out",
      "enter-active-class": "fadeInDown",
      "leave-active-class": "fadeOutUp",
      "appear": ""
    },
    on: {
      "after-enter": function($event) {
        _vm.hide(5000)
      }
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "animated message-box"
  }, [_c('article', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-header"
  }, [_c('p', [_vm._v(_vm._s(this.$store.state.error.name) + "!")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "delete"
    },
    on: {
      "click": function($event) {
        _vm.hide(0)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "message-body"
  }, [_vm._v("\n        " + _vm._s(this.$store.state.error.response ? this.$store.state.error.response.data.error.message : this.$store.state.error.message) + "\n      ")])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-layer"
  }, [_c('div', {
    staticClass: "hero is-fullheight"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container has-text-centered"
  }, [_c('span', {
    staticClass: "icon is-large has-text-white-ter"
  }, [_c('i', {
    staticClass: "fa fa-3x fa-question-circle-o"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title has-text-white-ter"
  }, [_vm._v("Error 404")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle has-text-white-ter"
  }, [_vm._v("Resource not found!")])])])])])
}]}

/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_vm._v("Users")])], 1), _vm._v(" "), _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v(_vm._s(this.$store.state.user.name || 'No name'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-1"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v(_vm._s(this.$store.state.user.name || 'No name'))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("User ID:")]), _vm._v(" " + _vm._s(_vm.$route.params.user_id))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Email:")]), _vm._v(" "), (this.$store.state.user.verified === false) ? _c('span', {
    staticClass: "icon has-text-warning",
    attrs: {
      "title": "Email is not confirmed"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning"
  })]) : _vm._e(), _vm._v(_vm._s(this.$store.state.user.email) + "\n      ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Created at:")]), _vm._v(" " + _vm._s(this.$store.state.user.created_at))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Updated at:")]), _vm._v(" " + _vm._s(this.$store.state.user.updated_at))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button is-primary is-outlined",
    attrs: {
      "to": ("/users/" + (this.$store.state.user.id) + "/edit")
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-pencil"
  })]), _vm._v(" "), _c('span', [_vm._v("Edit")])])], 1)])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-10 is-offset-1"
  }, [_c('h5', {
    staticClass: "subtitle is-5 has-text-centered has-text-blue-gray"
  }, [_vm._v("Smart things")]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-fullwidth"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(!this.$store.state.ownedThings.length && !this.$store.state.sharedThings.length && !this.$store.state.invitedThings.length) ? _c('tr', [_c('td', {
    staticClass: "has-text-centered has-text-grey",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("No smart things found")])]) : _vm._e(), _vm._v(" "), _vm._l((this.$store.state.ownedThings), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/products/" + (item.product_id) + "/things/" + (item.id))
      }
    }, [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.identifier))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.updated_at))])])
  }), _vm._v(" "), _vm._l((this.$store.state.sharedThings), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/products/" + (item.product_id) + "/things/" + (item.id))
      }
    }, [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.identifier))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.updated_at))])])
  }), _vm._v(" "), _vm._l((this.$store.state.invitedThings), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/products/" + (item.product_id) + "/things/" + (item.id))
      }
    }, [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.identifier))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.updated_at))])])
  })], 2)])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-10 is-offset-1"
  }, [_c('h5', {
    staticClass: "subtitle is-5 has-text-centered has-text-blue-gray"
  }, [_vm._v("Mobile devices")]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-fullwidth"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', [(!this.$store.state.userDevices.length) ? _c('tr', [_c('td', {
    staticClass: "has-text-centered has-text-grey",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("No mobile devices found")])]) : _vm._e(), _vm._v(" "), _vm._l((this.$store.state.userDevices), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.model))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.manufacturer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.platform))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.platform_ver))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.updated_at))])])
  })], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Role")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Identifier")]), _vm._v(" "), _c('th', [_vm._v("Created at")]), _vm._v(" "), _c('th', [_vm._v("Updated at")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "tag badge-owner"
  }, [_vm._v("owner")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "tag badge-guest"
  }, [_vm._v("guest")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "tag badge-invitee"
  }, [_vm._v("invitee")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Model")]), _vm._v(" "), _c('th', [_vm._v("Manufacturer")]), _vm._v(" "), _c('th', [_vm._v("Platform")]), _vm._v(" "), _c('th', [_vm._v("Version")]), _vm._v(" "), _c('th', [_vm._v("Created at")]), _vm._v(" "), _c('th', [_vm._v("Updated at")])])])
}]}

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero app-navbar"
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('div', {
    class: {
      'navbar-burger': true, 'burger': true, 'is-active': !_vm.showBurger
    },
    on: {
      "click": function($event) {
        _vm.$emit('toggleSidebar')
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "navbar-item is-size-5 has-text-weight-light"
  }, [_vm._v(_vm._s(this.$store.state.organization.name))])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu"
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('div', {
    staticClass: "navbar-item has-dropdown is-hoverable"
  }, [_c('a', {
    staticClass: "navbar-link"
  }, [_c('p', [_vm._m(0), _vm._v(" " + _vm._s(this.$store.state.customer.name))])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-dropdown is-right"
  }, [_vm._l((this.$store.state.organizations), function(organization) {
    return _c('div', [_c('a', {
      class: {
        'navbar-item': true, 'is-active': _vm.organizationIsActive(organization.id)
      },
      on: {
        "click": function($event) {
          _vm.switchOrganization(organization.id)
        }
      }
    }, [_c('div', {
      staticClass: "field"
    }, [_c('p', [_vm._v(_vm._s(organization.name))]), _vm._v(" "), _c('p', {
      staticClass: "has-text-grey-light"
    }, [_vm._v("id: " + _vm._s(organization.id) + " | slug: " + _vm._s(organization.slug))])])])])
  }), _vm._v(" "), _c('hr', {
    staticClass: "navbar-divider"
  }), _vm._v(" "), _c('a', {
    staticClass: "navbar-item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("Log out")])])], 2)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-user-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-sign-out"
  })])
}]}

/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('p', [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.usersTotal)))]), _vm._v(" users")])]), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "field has-addons"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValue),
      expression: "searchValue"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Find by"
    },
    domProps: {
      "value": (_vm.searchValue)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.searchUsers($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "name"
    }
  }, [_vm._v("name")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "email"
    }
  }, [_vm._v("email")])])])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.searchUsers
    }
  }, [_vm._v("Search")])])])])])]), _vm._v(" "), _c('pagination', {
    staticClass: "is-small",
    attrs: {
      "urlBuilder": _vm.buildPaginatorUrls,
      "currentPage": _vm.currentPage,
      "lastPage": _vm.lastPage,
      "displayPage": 5
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-fullwidth"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(!this.$store.state.users.length) ? _c('tr', [_c('td', {
    staticClass: "has-text-centered has-text-grey",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No users found")])]) : _vm._e(), _vm._v(" "), _vm._l((this.$store.state.users), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/users/" + (item.id))
      }
    }, [_vm._v(_vm._s(item.name || 'No name'))])], 1), _vm._v(" "), _c('td', [(item.verified === true) ? _c('span', {
      staticClass: "icon has-text-success tooltip",
      attrs: {
        "data-tooltip": "Email is confirmed"
      }
    }, [_c('i', {
      staticClass: "fa fa-check-circle"
    })]) : _c('span', {
      staticClass: "icon has-text-warning tooltip",
      attrs: {
        "data-tooltip": "Email is not confirmed"
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle"
    })]), _vm._v("\n          " + _vm._s(item.email) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.updated_at))])])
  })], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Created at")]), _vm._v(" "), _c('th', [_vm._v("Updated at")])])])
}]}

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 209 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Products")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/products/" + (this.$route.params.product_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.product.name))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/products/" + (this.$route.params.product_id) + "/fw_updates")
    }
  }, [_vm._v("Firmware updates")])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Version")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.version),
      expression: "fields.version"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          regex: /^\d{1,3}\.\d{1,3}(?:\.\d{1,6})?$/
        }
      }),
      expression: "{rules: {required: true, regex: /^\\d{1,3}\\.\\d{1,3}(?:\\.\\d{1,6})?$/}}"
    }],
    class: {
      'input': true, 'is-danger': _vm.veeErrors.has('version')
    },
    attrs: {
      "name": "version",
      "type": "text",
      "placeholder": "1.0.2",
      "data-vv-as": "Version"
    },
    domProps: {
      "value": (_vm.fields.version)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fields, "version", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('version')),
      expression: "veeErrors.has('version')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('version')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.description),
      expression: "fields.description"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'textarea': true, 'is-danger': _vm.veeErrors.has('description')
    },
    attrs: {
      "name": "description",
      "type": "text",
      "placeholder": "Some description here",
      "data-vv-as": "Description"
    },
    domProps: {
      "value": (_vm.fields.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fields, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('description')),
      expression: "veeErrors.has('description')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('description')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Firmware file")]), _vm._v(" "), _c('div', {
    staticClass: "file"
  }, [_c('label', {
    staticClass: "file-label"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'file-input': true, 'is-danger': _vm.veeErrors.has('file1')
    },
    attrs: {
      "name": "file1",
      "type": "file",
      "data-vv-as": "Firmware file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "file-cta"
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "file-label"
  }, [_vm._v(_vm._s(_vm.filename))])])])]), _vm._v(" "), _c('p', {
    staticClass: "help"
  }, [_vm._v("Must be a binary file.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('file1')),
      expression: "veeErrors.has('file1')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('file1')))])]), _vm._v(" "), _c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    class: {
      'button': true, 'is-primary': true, 'is-loading': _vm.isLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Upload")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": ("/products/" + (this.$route.params.product_id) + "/fw_updates"),
      "exact": ""
    }
  }, [_vm._v("Cancel")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Firmware upload")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "file-icon"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  })])
}]}

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('p', [_c('router-link', {
    staticClass: "button is-info",
    attrs: {
      "to": '/products/create'
    }
  }, [_vm._v("Create new product")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('p', [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.productsTotal)))]), _vm._v(" products")])])])]), _vm._v(" "), _c('pagination', {
    staticClass: "is-small",
    attrs: {
      "urlBuilder": _vm.buildPaginatorUrls,
      "currentPage": _vm.currentPage,
      "lastPage": _vm.lastPage,
      "displayPage": 5
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-fullwidth"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(!this.$store.state.products.length) ? _c('tr', [_c('td', {
    staticClass: "has-text-centered has-text-grey",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No products found")])]) : _vm._e(), _vm._v(" "), _vm._l((this.$store.state.products), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/products/" + (item.id))
      }
    }, [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.slug))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.updated_at))])])
  })], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Slug")]), _vm._v(" "), _c('th', [_vm._v("Created at")]), _vm._v(" "), _c('th', [_vm._v("Updated at")])])])
}]}

/***/ }),
/* 211 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Total products")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/products"
    }
  }, [_c('p', {
    staticClass: "subtitle is-4 has-text-primary"
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.productsTotal)))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Total applications")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/clients"
    }
  }, [_c('p', {
    staticClass: "subtitle is-4 has-text-primary"
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.clientsTotal)))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Total users")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_c('p', {
    staticClass: "subtitle is-4 has-text-primary"
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.usersTotal)))])])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 212 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Products")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/products/" + (this.$route.params.product_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.product.name))])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('p', [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.productThingsTotal)))]), _vm._v(" smart things")])]), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "field has-addons"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValue),
      expression: "searchValue"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Find by"
    },
    domProps: {
      "value": (_vm.searchValue)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.searchThings($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "name"
    }
  }, [_vm._v("name")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "identifier"
    }
  }, [_vm._v("identifier")])])])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.searchThings
    }
  }, [_vm._v("Search")])])])])])]), _vm._v(" "), _c('pagination', {
    staticClass: "is-small",
    attrs: {
      "urlBuilder": _vm.buildPaginatorUrls,
      "currentPage": _vm.currentPage,
      "lastPage": _vm.lastPage,
      "displayPage": 5
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-fullwidth"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [(!this.$store.state.productThings.length) ? _c('tr', [_c('td', {
    staticClass: "has-text-centered has-text-grey",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No smart things found")])]) : _vm._e(), _vm._v(" "), _vm._l((this.$store.state.productThings), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/products/" + (item.product_id) + "/things/" + (item.id))
      }
    }, [_vm._v(_vm._s(item.name || 'No name'))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.identifier))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.updated_at))])])
  })], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Smart things")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Identifier")]), _vm._v(" "), _c('th', [_vm._v("Created at")]), _vm._v(" "), _c('th', [_vm._v("Updated at")])])])
}]}

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/clients"
    }
  }, [_vm._v("Applications")])], 1), _vm._v(" "), (_vm.update == true) ? [_c('li', [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$route.params.client_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.client.name))])], 1), _vm._v(" "), _vm._m(0)] : _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Create a new application")])])], 2)]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showClientCredentialsModal
    },
    on: {
      "close": _vm.hideClientCredentialsModal
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v("Notice")])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('span', {
    staticClass: "icon is-large has-text-warning"
  }, [_c('i', {
    staticClass: "fa fa-3x fa-exclamation-triangle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('p', [_vm._v("Please, copy the "), _c('strong', [_vm._v("identifier")]), _vm._v(" below and store it in a safe place. This will not be shown again.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Identifier:")]), _vm._v(" "), _c('code', [_vm._v(_vm._s(this.$store.state.client.identifier))])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-success",
    on: {
      "click": _vm.hideClientCredentialsModal
    }
  }, [_vm._v("OK")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Application name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.name),
      expression: "fields.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-danger': _vm.veeErrors.has('name')
    },
    attrs: {
      "name": "name",
      "type": "text",
      "placeholder": "Application name",
      "data-vv-as": "Client name"
    },
    domProps: {
      "value": (_vm.fields.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fields, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('name')),
      expression: "veeErrors.has('name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('name')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Platform")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    class: {
      'select': true, 'is-danger': _vm.veeErrors.has('platform')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.platform),
      expression: "fields.platform"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "platform",
      "disabled": _vm.update,
      "data-vv-as": "Platform"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.fields, "platform", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select one option")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "android"
    }
  }, [_vm._v("Android")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ios"
    }
  }, [_vm._v("iOS")])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('platform')),
      expression: "veeErrors.has('platform')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('platform')))])]), _vm._v(" "), _c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    class: {
      'button': true, 'is-primary': true, 'is-loading': _vm.isLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": _vm.cancelUrl,
      "exact": ""
    }
  }, [_vm._v("Cancel")])], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Edit application name")])])
}]}

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Products")])], 1), _vm._v(" "), _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v(_vm._s(this.$store.state.product.name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-1"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v(_vm._s(this.$store.state.product.name))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Product ID:")]), _vm._v(" " + _vm._s(_vm.$route.params.product_id))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Slug:")]), _vm._v(" " + _vm._s(this.$store.state.product.slug))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Created at:")]), _vm._v(" " + _vm._s(this.$store.state.product.created_at))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Updated at:")]), _vm._v(" " + _vm._s(this.$store.state.product.updated_at))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Smart things total")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": ("/products/" + (this.$store.state.product.id) + "/things")
    }
  }, [_c('p', {
    staticClass: "subtitle is-4 has-text-primary"
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.productThingsTotal)))])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Firmware updates")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": ("/products/" + (this.$store.state.product.id) + "/fw_updates")
    }
  }, [_c('p', {
    staticClass: "subtitle is-4 has-text-primary"
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.fwUpdatesTotal)))])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4 is-offset-1"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button is-primary is-outlined",
    attrs: {
      "to": ("/products/" + (this.$store.state.product.id) + "/edit")
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-pencil"
  })]), _vm._v(" "), _c('span', [_vm._v("Edit")])])], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu app-sidebar nav-menu"
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("Menu")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-tachometer"
  })]), _vm._v(" Dashboard")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/products"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  })]), _vm._v(" Products")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/clients"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-mobile"
  })]), _vm._v(" Applications")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-users"
  })]), _vm._v(" Users")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "is-hidden-desktop"
  }, [_c('hr'), _vm._v(" "), _c('p', {
    staticClass: "menu-label"
  }, [_vm._m(0), _vm._v("\n      " + _vm._s(this.$store.state.customer.name) + "\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('a', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._m(1), _vm._v("Log out")])])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-user-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-sign-out"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-bottom has-text-centered has-text-grey"
  }, [_c('p', {
    staticClass: "is-size-7"
  }, [_vm._v("IoT Console")]), _vm._v(" "), _c('p', {
    staticClass: "is-size-7"
  }, [_vm._v("by "), _c('a', {
    attrs: {
      "href": "https://fusionnextinc.com/"
    }
  }, [_vm._v("Fusion Next Inc.")])])])
}]}

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterLeave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.deactive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.closable) ? _c('button', {
    staticClass: "modal-close",
    on: {
      "click": _vm.deactive
    }
  }) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 217 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 218 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Products")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/products/" + (this.$route.params.product_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.product.name))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/products/" + (this.$route.params.product_id) + "/things")
    }
  }, [_vm._v("Smart things")])], 1), _vm._v(" "), _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v(_vm._s(this.$store.state.thing.name || 'No name'))])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal
    },
    on: {
      "close": _vm.closeDeleteThingModal
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v("Deleting smart thing")])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('span', {
    staticClass: "icon is-large has-text-danger"
  }, [_c('i', {
    staticClass: "fa fa-3x fa-exclamation-triangle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('p', [_vm._v("Are you sure you want to "), _c('strong', [_vm._v("delete")]), _vm._v(" this smart thing?")]), _vm._v(" "), _c('p', [_vm._v("This action cannot be undone.")])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-danger",
    on: {
      "click": _vm.deleteItem
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.closeDeleteThingModal
    }
  }, [_vm._v("Cancel")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-1"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v(_vm._s(this.$store.state.thing.name || 'No name'))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Smart thing ID:")]), _vm._v(" " + _vm._s(_vm.$route.params.thing_id))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Identifier:")]), _vm._v(" " + _vm._s(this.$store.state.thing.identifier))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Product name:")]), _vm._v(" " + _vm._s(this.$store.state.product.name))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Created at:")]), _vm._v(" " + _vm._s(this.$store.state.thing.created_at))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Updated at:")]), _vm._v(" " + _vm._s(this.$store.state.thing.updated_at))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Latest online time:")]), _vm._v(" " + _vm._s(this.$store.state.states.length ? this.$store.state.states[0].updated_at : 'Unknown'))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button is-primary is-outlined",
    attrs: {
      "to": ("/products/" + (this.$route.params.product_id) + "/things/" + (this.$route.params.thing_id) + "/edit")
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-pencil"
  })]), _vm._v(" "), _c('span', [_vm._v("Edit")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button is-danger is-outlined",
    on: {
      "click": _vm.openDeleteThingModal
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Delete")])])])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-10 is-offset-1"
  }, [_c('h5', {
    staticClass: "subtitle is-5 has-text-centered has-text-blue-gray"
  }, [_vm._v("Users")]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-fullwidth"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [(!this.$store.state.owners.length && !this.$store.state.guests.length && !this.$store.state.invitees.length) ? _c('tr', [_c('td', {
    staticClass: "has-text-centered has-text-grey",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("No users found")])]) : _vm._e(), _vm._v(" "), _vm._l((this.$store.state.owners), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/users/" + (item.id))
      }
    }, [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.updated_at))])])
  }), _vm._v(" "), _vm._l((this.$store.state.guests), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/users/" + (item.id))
      }
    }, [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.updated_at))])])
  }), _vm._v(" "), _vm._l((this.$store.state.invitees), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _vm._m(4, true), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/users/" + (item.id))
      }
    }, [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.updated_at))])])
  })], 2)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-trash"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Role")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Created at")]), _vm._v(" "), _c('th', [_vm._v("Updated at")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "tag badge-owner"
  }, [_vm._v("owner")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "tag badge-guest"
  }, [_vm._v("guest")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "tag badge-invitee"
  }, [_vm._v("invitee")])])
}]}

/***/ }),
/* 220 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/clients"
    }
  }, [_vm._v("Applications")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$route.params.client_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.client.name))])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('p', [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.clientDevicesTotal)))]), _vm._v(" mobile devices")])])])]), _vm._v(" "), _c('pagination', {
    staticClass: "is-small",
    attrs: {
      "urlBuilder": _vm.buildPaginatorUrls,
      "currentPage": _vm.currentPage,
      "lastPage": _vm.lastPage,
      "displayPage": 5
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-fullwidth"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [(!this.$store.state.clientDevices.length) ? _c('tr', [_c('td', {
    staticClass: "has-text-centered has-text-grey",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("No mobile devices found")])]) : _vm._e(), _vm._v(" "), _vm._l((this.$store.state.clientDevices), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.model))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.manufacturer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.platform))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.platform_ver))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.updated_at))])])
  })], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Mobile devices")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Model")]), _vm._v(" "), _c('th', [_vm._v("Manufacturer")]), _vm._v(" "), _c('th', [_vm._v("Platform")]), _vm._v(" "), _c('th', [_vm._v("Version")]), _vm._v(" "), _c('th', [_vm._v("Created at")]), _vm._v(" "), _c('th', [_vm._v("Updated at")])])])
}]}

/***/ }),
/* 221 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    class: _vm.getNavClassName()
  }, [_c('router-link', {
    staticClass: "pagination-previous",
    attrs: {
      "to": _vm.urlBuilder(_vm.prevPage),
      "disabled": _vm.outOfRegion(_vm.formatCurrentPage - 1)
    }
  }, [_vm._v(_vm._s(_vm.prev))]), _vm._v(" "), _c('router-link', {
    staticClass: "pagination-next",
    attrs: {
      "to": _vm.urlBuilder(_vm.nextPage),
      "disabled": _vm.outOfRegion(_vm.formatCurrentPage + 1)
    }
  }, [_vm._v(_vm._s(_vm.next))]), _vm._v(" "), _c('ul', {
    staticClass: "pagination-list"
  }, _vm._l((_vm.pagingList), function(item) {
    return _c('li', [(item !== '...') ? _c('router-link', {
      class: _vm.getPagingClassName(item),
      attrs: {
        "to": _vm.urlBuilder(item)
      }
    }, [_vm._v(_vm._s(item))]) : _c('span', {
      staticClass: "pagination-ellipsis"
    }, [_vm._v("...")])], 1)
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Products")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/products/" + (this.$route.params.product_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.product.name))])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('p', [_c('router-link', {
    staticClass: "button is-info",
    attrs: {
      "to": ("/products/" + (this.$route.params.product_id) + "/fw_updates/create")
    }
  }, [_vm._v("Upload new firmware")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('p', [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.fwUpdatesTotal)))]), _vm._v(" firmware updates")])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal
    },
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v("Deleting firmware update")])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('span', {
    staticClass: "icon is-large has-text-danger"
  }, [_c('i', {
    staticClass: "fa fa-3x fa-exclamation-triangle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('p', [_vm._v("Are you sure you want to "), _c('strong', [_vm._v("delete")]), _vm._v(" this firwmare update?")]), _vm._v(" "), _c('p', [_vm._v("This action cannot be undone.")])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-danger",
    on: {
      "click": function($event) {
        _vm.deleteItem(_vm.fwUpdateId)
      }
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("Cancel")])])])]), _vm._v(" "), _c('pagination', {
    staticClass: "is-small",
    attrs: {
      "urlBuilder": _vm.buildPaginatorUrls,
      "currentPage": _vm.currentPage,
      "lastPage": _vm.lastPage,
      "displayPage": 5
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-fullwidth"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [(!this.$store.state.fwUpdates.length) ? _c('tr', [_c('td', {
    staticClass: "has-text-centered has-text-grey",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No firmware updates found")])]) : _vm._e(), _vm._v(" "), _vm._l((this.$store.state.fwUpdates), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": (_vm.apiUrl + "/fw_updates/" + (item.filename))
      }
    }, [_vm._v(_vm._s(item.filename))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.version))]), _vm._v(" "), _c('td', {
      staticClass: "text-column"
    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.updated_at))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "title": "Delete firmware file"
      },
      on: {
        "click": function($event) {
          _vm.showModal = true;
          _vm.fwUpdateId = item.id
        }
      }
    }, [_vm._m(2, true)])])])
  })], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Firmware updates")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Filename")]), _vm._v(" "), _c('th', [_vm._v("Version")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Updated at")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon has-text-danger"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-trash"
  })])
}]}

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterLeave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.deactive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._t("default")], 2)]), _vm._v(" "), (_vm.closable) ? _c('button', {
    staticClass: "modal-close",
    on: {
      "click": _vm.deactive
    }
  }) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app-main"
  }, [_c('div', {
    staticClass: "container is-fluid is-marginless app-content"
  }, [_c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "appear": ""
    }
  }, [_c('router-view', {
    staticClass: "animated"
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Products")])], 1), _vm._v(" "), (_vm.update == true) ? [_c('li', [_c('router-link', {
    attrs: {
      "to": ("/products/" + (this.$route.params.product_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.product.name))])], 1), _vm._v(" "), _vm._m(0)] : _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Create a new product")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Product name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.name),
      expression: "fields.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-danger': _vm.veeErrors.has('name')
    },
    attrs: {
      "name": "name",
      "type": "text",
      "placeholder": "Product name",
      "data-vv-as": "Product name"
    },
    domProps: {
      "value": (_vm.fields.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fields, "name", $event.target.value)
      }, function($event) {
        _vm.fields.slug = _vm.slug(_vm.fields.name, {
          lower: true
        })
      }]
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('name')),
      expression: "veeErrors.has('name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('name')))])]), _vm._v(" "), (_vm.update == false) ? _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Slug")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.slug),
      expression: "fields.slug"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|regex:^[a-z0-9]+(?:-[a-z0-9]+)*$'),
      expression: "'required|regex:^[a-z0-9]+(?:-[a-z0-9]+)*$'"
    }],
    class: {
      'input': true, 'is-danger': _vm.veeErrors.has('slug')
    },
    attrs: {
      "name": "slug",
      "type": "text",
      "placeholder": "product-slug",
      "data-vv-as": "Product slug"
    },
    domProps: {
      "value": (_vm.fields.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fields, "slug", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('slug')),
      expression: "veeErrors.has('slug')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('slug')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    class: {
      'button': true, 'is-primary': true, 'is-loading': _vm.isLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": _vm.cancelUrl,
      "exact": ""
    }
  }, [_vm._v("Cancel")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Edit product name")])])
}]}

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-fullheight"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-4 has-text-centered"
  }, [_vm._v("Please, authorize")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-4"
  }, [_c('div', {
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.login($event)
      },
      "input": _vm.clearError
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.username),
      expression: "credentials.username"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-medium': true, 'is-danger': _vm.veeErrors.has('username')
    },
    attrs: {
      "name": "username",
      "type": "email",
      "placeholder": "Enter your email"
    },
    domProps: {
      "value": (_vm.credentials.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('username')),
      expression: "veeErrors.has('username')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('username')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-medium': true, 'is-danger': _vm.veeErrors.has('password')
    },
    attrs: {
      "name": "password",
      "placeholder": "Enter your password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('password')),
      expression: "veeErrors.has('password')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('password')))])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [(_vm.error) ? _c('span', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "field is-grouped is-grouped-centered"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-dark",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hero-foot"
  }, [_c('div', {
    staticClass: "container has-text-centered has-text-grey"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "is-size-7"
  }, [_vm._v(_vm._s(_vm.year) + " ©")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "is-size-7"
  }, [_vm._v("IoT Console by "), _c('a', {
    attrs: {
      "href": "https://fusionnextinc.com/"
    }
  }, [_vm._v("Fusion Next Inc.")])])
}]}

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Products")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/products/" + (this.$route.params.product_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.product.name))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/products/" + (this.$route.params.product_id) + "/things")
    }
  }, [_vm._v("Smart things")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/products/" + (this.$route.params.product_id) + "/things/" + (this.$route.params.thing_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.thing.name || 'No name'))])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Smart thing name")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fields.name),
      expression: "fields.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-danger': _vm.veeErrors.has('name')
    },
    attrs: {
      "name": "name",
      "type": "text",
      "placeholder": "Smart thing name",
      "data-vv-as": "Smart thing name"
    },
    domProps: {
      "value": (_vm.fields.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.fields, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veeErrors.has('name')),
      expression: "veeErrors.has('name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.veeErrors.first('name')))])]), _vm._v(" "), _c('div', {
    staticClass: "field is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    class: {
      'button': true, 'is-primary': true, 'is-loading': _vm.isLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": ("/products/" + (this.$route.params.product_id) + "/things/" + (this.$route.params.thing_id)),
      "exact": ""
    }
  }, [_vm._v("Cancel")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Edit smart thing name")])])
}]}

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('p', [_c('router-link', {
    staticClass: "button is-info",
    attrs: {
      "to": '/clients/create'
    }
  }, [_vm._v("Create new application")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('p', [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.clientsTotal)))]), _vm._v(" applications")])])])]), _vm._v(" "), _c('pagination', {
    staticClass: "is-small",
    attrs: {
      "urlBuilder": _vm.buildPaginatorUrls,
      "currentPage": _vm.currentPage,
      "lastPage": _vm.lastPage,
      "displayPage": 5
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-fullwidth"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(!this.$store.state.clients.length) ? _c('tr', [_c('td', {
    staticClass: "has-text-centered has-text-grey",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No applications found")])]) : _vm._e(), _vm._v(" "), _vm._l((this.$store.state.clients), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/clients/" + (item.id))
      }
    }, [_vm._v(_vm._s(item.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.platform))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.updated_at))])])
  })], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Platform")]), _vm._v(" "), _c('th', [_vm._v("Created at")]), _vm._v(" "), _c('th', [_vm._v("Updated at")])])])
}]}

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out",
      "appear": "",
      "appear-active-class": _vm.enterClass,
      "enter-active-class": _vm.enterClass,
      "leave-active-class": _vm.leaveClass
    },
    on: {
      "beforeEnter": _vm.beforeEnter,
      "afterLeave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": _vm.deactive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.deactive
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.ok
    }
  }, [_vm._v(_vm._s(_vm.okText))]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/clients"
    }
  }, [_vm._v("Applications")])], 1), _vm._v(" "), _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v(_vm._s(this.$store.state.client.name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-1"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v(_vm._s(this.$store.state.client.name))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Application ID:")]), _vm._v(" " + _vm._s(_vm.$route.params.client_id))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Platform:")]), _vm._v(" " + _vm._s(this.$store.state.client.platform))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Created at:")]), _vm._v(" " + _vm._s(this.$store.state.client.created_at))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "has-text-grey"
  }, [_vm._v("Updated at:")]), _vm._v(" " + _vm._s(this.$store.state.client.updated_at))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Mobile devices total")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$store.state.client.id) + "/devices")
    }
  }, [_c('p', {
    staticClass: "subtitle is-4 has-text-primary"
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.clientDevicesTotal)))])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4 is-offset-1"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "button is-primary is-outlined",
    attrs: {
      "to": ("/clients/" + (this.$store.state.client.id) + "/edit")
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-pencil"
  })]), _vm._v(" "), _c('span', [_vm._v("Edit")])])], 1)])])])])
},staticRenderFns: []}

/***/ })
]),[78]);


// WEBPACK FOOTER //
// static/js/app.3a98eb863a1eecbf2315.js